import {
  Card,
  Icon,
  Spacer,
  Stack,
  Tag,
  TextBody,
  TextCaption,
} from '@pypestream/design-system';
import { useTranslation } from '@pypestream/translations';
import type { ReactNode } from 'react';

import './maestro-org.scss';

const key = (name: string) => `manager/organizations:orgTabs.${name}`;

export function NoAccessCard() {
  const { t } = useTranslation();
  return (
    <Card size="large" shadow="none" border="default" test-id="org-no-access">
      <div className="c-org-no-access">
        <span className="c-org-no-access__mark" aria-hidden="true">
          <Icon name="lock" />
        </span>
        <h2 className="c-org-no-access__title">{t(key('noAccess.title'))}</h2>
        <TextBody variant="secondary">{t(key('noAccess.body'))}</TextBody>
      </div>
    </Card>
  );
}

export function DefaultsBanner({
  org,
  section,
  viewOnly,
}: {
  org: string;
  section: 'ai-models' | 'voice';
  viewOnly: boolean;
}) {
  const { t } = useTranslation();
  return (
    <p className="c-org-banner" data-test-id="org-defaults-banner">
      <strong>{t(key('banner.lead'), { org })}</strong>{' '}
      {t(key(`banner.${section}`))}
      {viewOnly && ` ${t(key('banner.viewOnly'))}`}
    </p>
  );
}

export function CheckInTag() {
  const { t } = useTranslation();
  return <Tag size="small">{t(key('checkIn.tag'))}</Tag>;
}

/** Settings that still work but have no place in the design yet, flagged so product can decide. */
export function CheckInCard({
  title,
  children,
}: {
  title: string;
  children: ReactNode;
}) {
  const { t } = useTranslation();
  return (
    <Card size="large" shadow="none" border="default" test-id="org-check-in">
      <Stack alignItems="center" gutter="small" nowrap>
        <h2 className="c-org-card-title">{title}</h2>
        <CheckInTag />
      </Stack>
      <TextCaption variant="secondary">{t(key('checkIn.body'))}</TextCaption>
      <Spacer size="medium" />
      {children}
    </Card>
  );
}
